export default __webpack_public_path__ + "static/media/BlustreamPrivacyPolicy.de6644e6.pdf";